import { PATH_TOP_SPENDER } from "@configs";
import { selectAuth } from "@redux";
import { useNotify } from "@utils";
import { Modal } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { leaderboardAPI } from "src/API/leaderboard";
import { selectMerchant } from "src/Redux/Slices/merchant";
import styled from "styled-components";
import ModalHeaderIcon from "../../Components/icon/TopSpender/ModalHeaderIcon.svg";
import { ComponentPopUpTerms } from "../PopUpConfirm";
import { EditIcon } from "../icon/TopSpender/EditIcon";
interface IProps {
    handleModal: () => void;
    showModal: boolean;
    userInfo: any;
    themeColor: string;
    leaderboardId: string;
    confirmationImage: string;
    isActive: any;
}

export const TopSpenderModal = (props: IProps) => {
    const {
        handleModal,
        showModal,
        userInfo,
        themeColor,
        leaderboardId,
        confirmationImage,
        isActive,
    } = props;
    const { t } = useTranslation();
    const { success, error } = useNotify();
    const history = useHistory();
    const [isTermChecked, setIsTermChecked] = useState<boolean>(false);
    const [isTerm, setIsTerm] = useState<boolean>(false);
    const { themes } = useSelector(selectMerchant);

    const formattedText = {
        TermCondition: `
   <p> 1. สาขาที่ร่วมรายการเฉพาะโลตัส 229 สาขาเท่านั้น! </p> 

   <p> 2.เริ่มโปรโมชั่นและนำใบเสร็จมาร่วมรายการได้ตั้งแต่วันที่ 1 กันยายน 2566 – 15 ตุลาคม 2566 เวลา 22.00 น.</p>

   <p> 3.ลูกค้าซื้อสินค้าที่ร้านแว่นท็อปเจริญได้ทุกประเภทโดยไม่มีขั้นต่ำ และสามารถใช้ร่วมกับโปรโมชั่นหรือส่วนลดอื่นๆได้</p>

   <p> 4. แอดไลน์หรือเพิ่มเพื่อนมาที่ Line@Topcharoen ลงทะเบียนด้วยข้อมูลส่วนตัว ชื่อ-สกุล เบอร์โทรศัพท์ เพื่อสะสมยอดซื้อสูงสุด</p>
   <p> 5. สะสมยอดซื้อสูงสุดเป็น 100 ท่านแรก รับสิทธิ์ Exclusive Park Seo Jun Meet & Greet in Bangkok</p>

   <p> 6.ประกาศผลรายชื่อผู้ที่ได้รับสิทธิ์เข้าร่วมExclusive Park Seo Jun Meet&Greet in Bangkok ในวันที่ 17 ตุลาคม 2566 เวลา 10.00 น.ผ่านทาง Line@Topcharoen และ Facebook – Top Charoen Optical-Official</p>

   <p> 7. การส่งใบเสร็จรับเงิน บริษัทฯจะนำเฉพาะยอดเงินสุทธิหรือหลังหักส่วนลด เป็นที่เรียบร้อยแล้ว</p>

   <p> 8. ในการจัดลำดับ จะนับจากลำดับที่ส่งใบเสร็จรับเงิน (ตรงตามเงื่อนไขที่ร่วมรายการ )นับจากวันและเวลาที่ส่งเท่านั้น</p>

   <p> 9. ในกรณียอดซื้อเท่ากัน ผู้ที่ลงทะเบียนก่อนจะได้สิทธิ์ดังกล่าว</p>

   <p> 10. ใบเสร็จที่เข้าร่วมรายการ จะต้องเป็นใบเสร็จที่ดำเนินการชำระเงินแล้วเท่านั้น สามารถเข้าร่วมได้ทั้งใบเสร็จและใบกำกับภาษีอย่างย่อ หรือแบบเต็มรูป</p>

   <p> 11. การจัดลำดับที่นั่ง จะยึดจากตำแหน่งที่นั่งที่ดีที่สุดและลำดับถัดไป</p>

   <p> 12. ในการจัด Exclusive Park Seo Jun Meet & Greet in Bangkok จะถูกจัดขึ้นในวันที่ 21 ตุลาคม 2566 เวลา 17.00 น. – 18.30 น. ณ.ศูนย์ประชุมแห่งชาติสิริกิติ์ และขอสงวนสิทธิ์ในสถานการณ์ปกติ หากมีสถานการณ์โรคระบาดทำให้ไม่สามารถจัดกิจกรรมดังกล่าวได้ บริษัทฯขอสงวนสิทธิ์ในการเลื่อนหรือเปลี่ยนแปลงข้อมูลเกี่ยวกับการแสดง สถานที่ วันและเวลา โดยแจ้งให้ทราบอีกครั้ง </p>

   <p> 13. ไม่สามารถมอบสิทธิ์ โอนสิทธิ์ ให้กับบุคคลอื่นได้ในทุกกรณี</p>

   <p> 14. การซื้อขายสิทธิ์ อยู่นอกเหนือการควบคุมของบริษัทฯจึงไม่ต้องรับผิดชอบในทุกๆกรณี</p>

   <p> 15. ผู้ที่ได้รับสิทธิ์ร่วมงาน Exclusive Park Seo Jun Meet & Greet in Bangkok จะต้องยืนยันสิทธิ์ในการเข้าร่วมภายในวันที่ 19 ตุลาคม 2566 เท่านั้นและจะต้องแสดงบัตรประชาชน (ตัวจริง) เพื่อรับบัตรเข้างานเท่านั้น</p>

   <p> 16. การรับบัตรเข้างาน สามารถเข้ารับได้ ณ วันที่ 21 ต.ค. 66 ณ ร้านแว่น LUXOPTIC สาขา ศูนย์การประชุมแห่งชาติสิริกิติ์ ชั้น LG ตั้งแต่เวลา 11.00 น เป็นต้นไป</p>

   <p> 17.บริษัทฯสงวนสิทธิ์การเปลี่ยนแปลงข้อกำหนด และเงื่อนไข โดยไม่ต้องแจ้งให้ทราบล่วงหน้า กรณีพิพาท คำตัดสินของบริษัทฯถือเป็นที่สิ้นสุด</p>`,
    };

    // const registerHandler = async () => {
    //     try {
    //         const register = await topCharoenAPI.clientRegisterCampaign({
    //             organization_id: userInfo.merchantId,
    //             campaign_top_spender_id: "",
    //             profile_id: userInfo._id,
    //         });
    //         if (register.data.error === "0") {
    //             success(t("message.register.success"));
    //             history.push(PATH_TOP_SPENDER + "/list");
    //         } else {
    //             error(register.data.msg);
    //         }
    //     } catch (err: any) {
    //         error(err.message);
    //     }
    // };
    const registerHandler = async () => {
        try {
            const register = await leaderboardAPI.clientRegisterLeaderboard({
                contactId: userInfo?.contact?._id,
                leaderboardIds: leaderboardId,
            });
            if (register.data.success) {
                success(t("message.register.success"));
                history.push(PATH_TOP_SPENDER + "/list/" + leaderboardId);
            } else {
                error(register.data.message);
            }
        } catch (err: any) {
            err.response?.data?.message ? error(err.response?.data?.message) : error(err.message);
        }
    };
    const { terms } = useSelector(selectAuth);

    const handleTerms = () => {
        setIsTerm(!isTerm);
        setIsTermChecked(true);
    };

    const handleChange = () => {
        setIsTermChecked(!isTermChecked);
    };

    return (
        //@ts-ignore
        <ModalStyle
            footer={null}
            visible={showModal}
            onCancel={handleModal}
            closable={false}
            width={350}
            style={{ top: "40%" }}
        >
            <StyledModal color={themes?.themeColor ? themeColor : "#000"}>
                <img
                    className="modalHeaderIcon"
                    src={confirmationImage ? confirmationImage : ModalHeaderIcon}
                    alt="test"
                />
                {isActive ? (
                    <h2>{t("page.please_confirm_your_phone_number")}</h2>
                ) : (
                    <h2>{t("page.leaderboard_disabled")}</h2>
                )}

                {isActive && (
                    <p>
                        {userInfo.phoneNumber}{" "}
                        <a target="_blank" onClick={() => history.push("/profile")}>
                            <div className="editDiv">
                                <EditIcon color={themes?.themeColor} /> {t("page.edit")}
                            </div>
                        </a>
                    </p>
                )}
                {/* <div className="centerCheckBox">
                    <SharedCheckBox
                        name="acceptTermsAndConditions"
                        value={isTermChecked}
                        onChange={handleChange}
                        label={<span>ฉันยอมรับ </span>}
                    />
                    <span onClick={handleTerms} style={{ color: "#3293dc" }}>
                        เงื่อนไขการร่วมรายการ
                    </span>
                </div> */}
                {isActive ? (
                    <div className="modalButtons">
                        <button onClick={handleModal}>{t("page.cancel")}</button>
                        <button
                            className="confirmBtn"
                            onClick={registerHandler}
                            // disabled={isTermChecked ? false : true}
                        >
                            {t("page.confirm")}
                        </button>
                    </div>
                ) : (
                    <div className="modalButtons">
                        <button
                            className="confirmBtn"
                            onClick={() => history.push("/")}
                            // disabled={isTermChecked ? false : true}
                        >
                            {t("page.confirm")}
                        </button>
                    </div>
                )}
            </StyledModal>
            {isTerm && (
                <ComponentPopUpTerms
                    data={formattedText}
                    handleConfirm={handleTerms}
                    showTerm={isTerm}
                    termsTitle={"page.top_charoen_terms_title"}
                />
            )}
        </ModalStyle>
    );
};
const StyledModal = styled.div<{ color: string }>`
    h2 {
        color: #000;
        text-align: center;
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: inherit;
    }
    p {
        color: #c4a363;
        text-align: center;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: inherit;
        display: flex;
        gap: 8px;
        place-content: center;
        .editDiv {
            color: ${(p) => p.color};
            text-align: center;
            font-size: 14px;
            font-style: normal;
            font-weight: 700;
            line-height: inherit;
            cursor: pointer;
        }
    }
    .editDiv {
        display: flex;
        gap: 4px;
        align-items: center;
    }
    .modalButtons {
        margin-top: 32px;
        display: flex;
        flex-direction: row;
        gap: 12px;
        button {
            border-radius: 14px;
            border: 0.8px solid #e1e1e1;
            background: #fff;
            padding: 14.5px 0;
            color: #000;
            text-align: center;
            font-size: 13px;
            font-style: normal;
            font-weight: 700;
            line-height: inherit;
            width: 100%;
            cursor: pointer;
        }
        .confirmBtn {
            border-radius: 14px;
            background: ${(p) => p.color};
            color: #fff;
        }
    }
    .centerCheckBox {
        display: flex;
        place-content: center;
    }
`;
const ModalStyle = styled(Modal)`
    .ant-modal-content {
        border-radius: 16px;
    }
    .modalHeaderIcon {
        position: absolute;
        top: -80px;
        left: 0;
        right: 0;
        margin: auto;
        max-width: 230px;
        max-height: 150px;
    }
    .ant-modal-body {
        padding: 76px 16px 16px 16px;
        position: relative;
    }
`;
